import React from 'react';

export const GenerateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.296 8.12484C10.8732 8.03818 10.4852 7.82931 10.18 7.52415C9.87482 7.21898 9.66596 6.83095 9.5793 6.40817L8.49596 1.0415L7.37096 6.39567C7.2865 6.82073 7.07861 7.21147 6.77328 7.51902C6.46796 7.82658 6.07874 8.0373 5.6543 8.12484L2.2793 8.82484L5.6543 9.52067C6.07662 9.60833 6.46412 9.81752 6.76911 10.1225C7.07411 10.4275 7.2833 10.815 7.37096 11.2373L8.49596 16.5748L9.5793 11.2248C9.66696 10.8025 9.87615 10.415 10.1811 10.11C10.4861 9.80503 10.8736 9.59583 11.296 9.50817L14.671 8.81234L11.296 8.12484Z"
      fill="#27B0E0"
    />
    <path
      d="M17.3246 16.2915C17.1606 16.2576 17.01 16.1764 16.8915 16.0579C16.7731 15.9394 16.6919 15.7889 16.6579 15.6248L16.2413 13.5415L15.8246 15.6248C15.7938 15.7903 15.7136 15.9425 15.5946 16.0615C15.4756 16.1805 15.3234 16.2607 15.1579 16.2915L13.8496 16.5665L15.1579 16.8373C15.3234 16.8682 15.4756 16.9483 15.5946 17.0673C15.7136 17.1863 15.7938 17.3386 15.8246 17.504L16.2413 19.5873L16.6579 17.504C16.6919 17.3399 16.7731 17.1894 16.8915 17.0709C17.01 16.9525 17.1606 16.8713 17.3246 16.8373L18.6371 16.5665L17.3246 16.2915Z"
      fill="#27B0E0"
    />
    <path
      d="M2.91634 2.76683L3.68301 2.6085L2.91634 2.446C2.81517 2.43115 2.72099 2.38564 2.64649 2.31561C2.57199 2.24558 2.52075 2.15439 2.49967 2.05433L2.24967 0.833496L1.99551 2.05433C1.97609 2.15095 1.92855 2.23967 1.85887 2.30935C1.78918 2.37904 1.70046 2.42658 1.60384 2.446L0.833008 2.6085L1.60384 2.76683C1.70001 2.78725 1.78819 2.83512 1.85771 2.90463C1.92722 2.97415 1.97509 3.06233 1.99551 3.1585L2.27051 4.37516L2.52051 3.15433C2.54195 3.05838 2.59075 2.9707 2.66101 2.90193C2.73126 2.83315 2.81996 2.78622 2.91634 2.76683Z"
      fill="#27B0E0"
    />
  </svg>
);
